import React from 'react';
import { styled } from '@linaria/react';

import SleekToggleButtonGroup, {
  Props as SleekToggleButtonGroupProps,
} from '@/components/SleekToggleButtonGroup';

export interface Props
  extends Omit<SleekToggleButtonGroupProps, 'handleSelect'> {
  id: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  label: string;
  inline?: boolean;
  inlineMinWidth?: number;
  wrapperStyle?: React.CSSProperties;
}

function ToggleButtonGroupControl({
  id,
  value,
  setValue,
  label,
  inline,
  wrapperStyle,
  ...delegated
}: Props) {
  const Wrapper = inline ? InlineWrapper : StackedWrapper;

  return (
    <Wrapper style={wrapperStyle}>
      {label && <Label>{label}:</Label>}
      <SleekToggleButtonGroup
        id={id}
        value={value}
        {...delegated}
        handleSelect={setValue}
      />
    </Wrapper>
  );
}

const StackedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InlineWrapper = styled(StackedWrapper)`
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0px 20px;
  /* Trigger the wrap before they're all the way at the end: */
  padding-inline: 32px;
`;

const Label = styled.span`
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
`;

export default ToggleButtonGroupControl;
